import { useQuery } from '@tanstack/react-query';

import type { ObservationConfig } from '@cognite/apm-client';

import { useFDMServices } from '../../../../providers/fdm-services/fdm-services.context';
import { QueryKeys } from '../../../../utils/queryKeys';

export const useObservationConfigQuery = () => {
  const { apmClient } = useFDMServices();

  return useQuery<ObservationConfig[], Error>({
    queryKey: [QueryKeys.OBSERVATION_CONFIG, 'list'],
    queryFn: async () => {
      const {
        list: { items: observationConfigs },
      } = await apmClient.observationConfig.list(
        `
        externalId
        rootLocationExternalIds
        fieldConfigurations
      `
      );

      return observationConfigs;
    },
    meta: { error: { captureError: true } },
  });
};
